/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React from "react";
import { FaLinkedin } from "react-icons/fa";
// import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from "react-icons/fa";
import {
  MdOutlineMail,
  MdOutlineLocationOn,
  // MdOutlineLocalPhone,
} from "react-icons/md";
import SeQuenXLogo from "../assets/svg/SeQuenXLogo.svg";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const quickLinks = t("footer.quickLinks", { returnObjects: true });
  const policies = t("footer.policies", { returnObjects: true });

  return (
    <footer className="bg-white">
      <div className="container mx-auto max-w-7xl px-4 py-8">
        {/* Main Content */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          {/* Left Section - Logo and Description */}
          <div className="flex-1 max-w-md">
            <img src={SeQuenXLogo} alt="logo" className="w-28 mb-4" />
            <p className="text-gray-500 text-sm mb-6">
              {t("footer.description")}
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.linkedin.com/company/sequenx-b.v./"
                target="_blank"
                className="text-gray-400 hover:text-[#455590] transition-colors duration-300"
                rel="noreferrer"
              >
                <FaLinkedin size={18} />
              </a>
              <a
                href="mailto:info@sequenx.com"
                className="text-gray-400 hover:text-[#455590] transition-colors duration-300"
              >
                <MdOutlineMail size={18} />
              </a>
            </div>
          </div>

          {/* Right Section - Links */}
          <div className="flex-1 grid grid-cols-2 gap-8">
            <div>
              <h3 className="text-[#455590] text-xs font-semibold mb-3 uppercase tracking-wider">
                {t("footer.quickLinksTitle")}
              </h3>
              <ul className="space-y-2">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.link}
                      className="text-gray-500 text-sm hover:text-[#455590] transition-colors duration-300"
                    >
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-[#455590] text-xs font-semibold mb-3 uppercase tracking-wider">
                {t("footer.policiesTitle")}
              </h3>
              <ul className="space-y-2">
                {policies.map((policy, index) => (
                  <li key={index}>
                    <a
                      href={policy.link}
                      className="text-gray-500 text-sm hover:text-[#455590] transition-colors duration-300"
                    >
                      {policy.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-xs">
              &copy; 2016 - {new Date().getFullYear()} {t("footer.copyright")}
            </p>
            <p className="text-gray-400 text-xs">{t("footer.officeHours")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
